import { queryOptions } from "@tanstack/react-query";
import { experienceApi } from "@/lib/api";
import { onboardingKeys } from "./query-keys";

export type EligibilityResponse = {
  active: boolean;
  dismissed: boolean;
};

const fetchEligibility = async (
  orgId?: string,
  projectId?: string
): Promise<EligibilityResponse> => {
  const res = await experienceApi.get<EligibilityResponse>(
    "/api/onboarding/eligibility",
    { params: { orgId, projectId } }
  );
  return res.data;
};

export const eligibilityQueryOptions = (orgId?: string, projectId?: string) =>
  queryOptions({
    queryKey: onboardingKeys.eligibility({
      scope: { organizationId: orgId, projectId },
    }),
    queryFn: () => fetchEligibility(orgId, projectId),
    // Eligibility depends on live project membership (solo projects only). Use
    // shared query defaults so membership changes can refetch on focus/mount.
  });
